import React, { Component } from 'react'
import Icon from 'svg-inline-react'
import TARGET_ICON from '!svg-inline?removeTags=true!images/svg/user-target.svg'	
import MAGNIFY_ICON from '!svg-inline?removeTags=true!images/svg/user-search.svg'	
import SalesforceOwnerToggles from 'components/Integration/pages/SalesforceConfig/OwnerRouting'
import SalesforceLeadRouting from './containers/SalesforceLeadRouting'
import { APP_URL, SALESFORCE_CLIENT_ID } from 'constants/ResourcesConstants'
import ACCESS from 'utils/Access'
import IntegrationConnector from 'components/Integration/components/IntegrationConnector'
import { salesforceAction } from 'app/modules/rules/models'

import './style.styl'

class SalesforceFilter extends Component {

  constructor(props) {
    super(props)

    props.setPageValidity(true)
    this.state = {
      sfdcConnected: false,
      hasSalesforceRoutingSettingsEnabled: ACCESS.hasGates('salesforce_routing_settings_enabled')
    }
  }

  onSalesforceLeadRoutingSettingsUpdated = (settings) => {
    const settingsPayload = {"settings" : settings}
    this.props.updateSalesforceLeadRoutingSettings(settingsPayload)
    this.setState({ selectedSalesforceLeadRoutingSettings: settings})
  }

  onSalesforceLeadRoutingTogglesUpdated = (toggles) => {
    this.props.updateSalesforceLeadRoutingToggles(toggles)
    this.setState({ selectedSalesforceLeadRoutingToggles: toggles})
  }

  renderLeadRouting() {
    return(
      <SalesforceLeadRouting
        onSalesforceLeadRoutingSettingsUpdated={this.onSalesforceLeadRoutingSettingsUpdated}
        onSalesforceLeadRoutingTogglesUpdated={this.onSalesforceLeadRoutingTogglesUpdated}
        selectedSalesforceLeadRoutingSettings={this.state.selectedSalesforceLeadRoutingSettings}
        selectedSalesforceLeadRoutingToggles={this.state.selectedSalesforceLeadRoutingToggles}
      />
    )
  }
  
  renderOldLeadRouting() {
    return (
      <div className="rules-old-lead-routing-form">
        <p><Icon src={TARGET_ICON} /> When a known user chats in to Drift, we’ll use their email to see if they exist in Salesforce and will find the appropriate owner in the following order. Simply uncheck the fields you want us to skip:</p>
        <SalesforceOwnerToggles className="owner-routing-toggles"/>
        <p><Icon src={MAGNIFY_ICON} />If we can’t map an owner to a Drift teammate, we’ll carry on with your other Routing Rules</p>
      </div>      
    )
  }

  onIntegrationConnected = () => {
    this.setState({ sfdcConnected: true })
    this.props.setPageValidity(true)
    this.props.updateAction({
      ...salesforceAction,
      options: {}
    })
  }

  renderSFDCConnect() {
    const SalesforcePayload = {
      client_id: SALESFORCE_CLIENT_ID,
      response_type: 'code',
      redirect_uri: `${APP_URL}/accept-integration/salesforce`
    }
    const SaleseforceAuthUrl = 'https://login.salesforce.com/services/oauth2/authorize'
    return (
      <div className="rules-sfdc-connect">
        <h3>You need to connect your salesforce account before you can continue.</h3>
        <IntegrationConnector
          onIntegrationConnected={this.onIntegrationConnected}
          integrationId="salesforce"
          isOauth={true}
          oauthLink={SaleseforceAuthUrl}
          oauthQueryParams={SalesforcePayload}/>
      </div>
    )
  }

  render() {
    const { sfdcConnected, hasSalesforceRoutingSettingsEnabled } = this.state

    return (
      <div className="rules-salesforce-filter rules-choice">
        <header>
          <h1>Salesforce Owner</h1>
          { hasSalesforceRoutingSettingsEnabled ?
            <div>
              <p>When a known user chats in to Drift, we’ll use their email to see if they exist in <br/>Salesforce and will find the appropriate owner in cascading order.</p>
            </div> 
            : <div>
              <p>Add an identified contact’s Account, Contact or Lead Owner to new conversations. Learn More</p>
            </div>
          }
        </header>
        <div className="rules-editor-content">
          { sfdcConnected ? 
            <div className="rules-choice-content drift-form">
              {hasSalesforceRoutingSettingsEnabled ? this.renderLeadRouting() : this.renderOldLeadRouting()}
            </div>  
            : this.renderSFDCConnect()
          }
        </div>
      </div>
    )
  }
}

export default SalesforceFilter



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/SalesforceFilter/index.js